import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
interface Props {
  title: string;
}
export function PlpPageHeader(t0) {
  const $ = _c(4);
  const {
    title
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BreadcrumbItem><BreadcrumbLink asChild={true} className="text-xs font-bold"><Link href="/">Home</Link></BreadcrumbLink></BreadcrumbItem>;
    t2 = <BreadcrumbSeparator />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <header className="flex flex-col gap-4"><Breadcrumb><BreadcrumbList>{t1}{t2}<BreadcrumbItem><BreadcrumbPage className="text-xs font-medium">{title}</BreadcrumbPage></BreadcrumbItem></BreadcrumbList></Breadcrumb><h1 className="text-3xl md:text-4xl font-black tracking-tight">{title}</h1></header>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}